module.exports = __webpack_public_path__ + "img/00002.4ba2d4e8.webp";